export default {"src":"/_next/static/media/google.639059eb.svg","height":16,"width":16};